/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ClickableDiv from 'components/Common/ClickableDiv';
import Market, { Categories as MarketCategories } from 'models/business/Market';
import pchomeLogo from 'assets/pchome-logo.png';
import shopeeLogo from 'assets/shopeeLoge.png';
import Styles from './index.module.css';

export default function MarketButton({
  market,
  selected,
  expanded,
  onClick,
}) {
  return (
    <ClickableDiv
      onClick={onClick}
      className={classNames(
        Styles.mainContainer,
        {
          [Styles.mainContainerExpanded]: expanded,
          [Styles.mainContainerSelected]: selected,
        },
      )}
    >
      <div className={Styles.label}>
        {market.name}
      </div>
      <img
        className={classNames(Styles.icon, { [Styles.iconHidden]: !expanded })}
        alt=""
        src={market.category === MarketCategories.PChome ? pchomeLogo : shopeeLogo}
      />
    </ClickableDiv>
  );
}

MarketButton.propTypes = {
  market: PropTypes.instanceOf(Market),
  selected: PropTypes.bool,
  expanded: PropTypes.bool,
  onClick: PropTypes.func,
};

MarketButton.defaultProps = {
  market: new Market(),
  selected: false,
  expanded: false,
  onClick: () => {},
};
